import * as React from "react";
import { Clock, PhoneMissed, CalendarX, CircleAlert } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
const problemStats = [{
  title: "۱۰+ سال تجربه بالینی",
  icon: Clock,
  stat: "۱۰+",
  description: "بیش از یک دهه همراهی با مراجعان در مسیر بهبود سلامت روان و مدیریت چالش‌های زندگی با رویکردهای علمی."
}, {
  title: "تخصص در پژوهش",
  icon: CircleAlert,
  stat: "PhD",
  description: "دکترای تخصصی روانشناسی با تمرکز بر پژوهش‌های نوین در حوزه هیجانات و دردهای مزمن مانند میگرن."
}, {
  title: "تعهد به مراجع",
  icon: CalendarX,
  stat: "۱۰۰٪",
  description: "ایجاد فضایی امن، محرمانه و بدون قضاوت برای واکاوی عمیق مسائل فردی و خانوادگی شما."
}];
export default function TheHiddenCostOfMissedLeads() {
  return <section data-section-id="223375" id="چرا-به-من-اعتماد-کنید" className="bg-background text-foreground py-24 px-6 md:px-12 relative overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-secondary/10 via-background to-background pointer-events-none" />

      <div className="max-w-6xl mx-auto relative z-10">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <div className="inline-flex items-center justify-center gap-2 px-3 py-1.5 mb-6 rounded-lg bg-accent/50 border border-border text-accent-foreground text-sm font-default">
            <CircleAlert className="size-4" />
            <span>تخصص و تجربه در خدمت آرامش شما</span>
          </div>
          <h2 className="font-default text-3xl md:text-5xl font-bold tracking-tight mb-6 text-foreground">
            چرا به من اعتماد کنید؟
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl font-default">
            انتخاب یک درمانگر مناسب، اولین قدم برای تغییر است. من با تکیه بر دانش آکادمیک و سال‌ها تجربه عملی، در این مسیر کنار شما هستم.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {problemStats.map((item, i) => <Card key={i} data-index={i} className="bg-card/30 backdrop-blur-sm border-border/40 hover:border-secondary/50 transition-all duration-300 shadow-md hover:shadow-xl rounded-lg">
              <CardHeader className="pb-4">
                <div className="size-12 rounded-lg bg-secondary/10 flex items-center justify-center mb-4 border border-secondary/20">
                  <item.icon className="size-6 text-secondary" />
                </div>
                <CardTitle className="font-default text-xl text-foreground">
                  {item.title}
                </CardTitle>
              </CardHeader>
              <CardContent>
                <div className="mb-4">
                  <span className="font-default text-5xl font-bold text-secondary tracking-tighter">
                    {item.stat}
                  </span>
                </div>
                <p className="text-muted-foreground leading-relaxed font-default">
                  {item.description}
                </p>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}